// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"src-components-UI-UserAvatar-styles-style-module__userAvatar--1cQ3l","imageWrapper":"src-components-UI-UserAvatar-styles-style-module__imageWrapper--2sfib"};